import { ViewportScroller } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService } from '../../services/config/app-config.service';
import { TokenStorageService } from '../../services/storage/token-storage.service';
import { AuthService } from '../../services/auth.service';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { UserService } from '../../services/user.service';
import { ToastrService } from 'ngx-toastr';
import {
  KeycloakEventLegacy,
  KeycloakEventTypeLegacy,
  KeycloakService,
} from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { environment } from '../../../../src/environments/environment';
import { MaintenanceService } from '../../services/maintenance.service';
import { WindowRefService } from '../../services/window/window-ref.service';
import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LoginService } from '../../services/login.service';
import { RegistrationModalService } from '../../services/registration-modal.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    standalone: false
})
export class NavbarComponent implements OnInit {
  isLoggedIn = false;
  isInitialLogin = false;
  oms = true;
  showAdminComponents = false;
  showBrokerComponents = false;
  showBrokerAdminComponents = false;
  showInternalUserComponents = false;
  showSysAdminComponents: boolean = false;

  username?: string;
  user: any;
  tradeDomain: string | undefined;
  priceDomain: string | undefined;
  activePage = '';
  userType = 'OMS';

  apis: any[] = [];
  institutionId: any;
  isRestAPIEnabled: boolean = false;
  isExternalAPIEnabled: boolean = false;
  isEmbedAPIEnabled: boolean = false;
  isDWMAPIEnabled: boolean = false;
  openAPIEnabled: any;
  embedAPIEnabled: any;
  backOfficeAPIEnabled: any;
  dwmAPIEnabled: any;
  feedAPIEnabled: any;
  loggedInUser: any;
  countries: any[] = [];
  loading: boolean = false;
  userDetails: KeycloakProfile | null = null;

  constructor(
    private tokenStorageService: TokenStorageService,
    private scroller: ViewportScroller,
    private router: Router,
    private authService: AuthService,
    private appConfig: AppConfigService,
    private modalService: MdbModalService,
    private userService: UserService,
    private toastr: ToastrService,
    private keycloakService: KeycloakService,
    private maintenanceService: MaintenanceService,
    private windowRef: WindowRefService,
    private loginService: LoginService,
    private registrationModalService: RegistrationModalService,
  ) {
    const hostname = this.windowRef.nativeWindow.location.hostname;
    this.tradeDomain = appConfig.getCommonConfig?.tradeDomain;
    this.priceDomain = appConfig.getCommonConfig?.priceDomain;
    this.userType =
      hostname == this.priceDomain
        ? 'FEED'
        : hostname == this.tradeDomain
          ? 'OMS'
          : '';
  }

  ngOnInit(): void {
    this.setActiveFromUrl(this.router.url);
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.setActiveFromUrl(e.urlAfterRedirects));

    this.userType = 'OMS';
    if (this.userType === 'OMS') {
      if (this.keycloakService.isLoggedIn()) {
        this.loadUserDetails();
        // initialize() is called from getUserDetails() when API returns; avoid duplicate init
        this.keycloakService.keycloakEvents$.subscribe({
          next: (event: KeycloakEventLegacy) => {
            if (event.type === KeycloakEventTypeLegacy.OnTokenExpired) {
              this.toastr.warning('Session expired.Log in again...');
              window.location.reload();
              this.logout();
            }
          },
          error: (err) => {
            console.error('Keycloak event error', err);
          },
        });
      }
    } else if (this.userType === 'FEED') {
      this.initialize();
    }
  }

  initialize(): void {
    console.log('Initializing NavbarComponent...');
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    console.log('isLoggedIn', this.isLoggedIn);
    this.isInitialLogin =
      this.tokenStorageService.getUser()?.initialLoginFlag === 1;

    // ✅ FIX: use robust URL mapping instead of split('/')[1]
    this.setActiveFromUrl(this.router.url);

    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();
      if (this.userType === 'OMS') {
        this.showAdminComponents =
          this.tokenStorageService.getUser().role == 'admin';
        this.showBrokerComponents =
          this.tokenStorageService.getUser().role == 'broker';
        this.showBrokerAdminComponents =
          this.tokenStorageService.getUser().role == 'brokerAdmin';
        this.showInternalUserComponents =
          this.tokenStorageService.getUser().role == 'internalUser';
        this.showSysAdminComponents =
          this.tokenStorageService.getUser().role === 'sysAdmin';
      }
      this.oms = this.tokenStorageService.getUserType() == 'OMS';
      this.username = this.user.username;
      this.oms = true;
      console.log('username', this.username);
      console.log('oms', this.oms);

      // Check for maintenance notifications after login
      this.maintenanceService.checkForMaintenance();
    }
    if (
      this.showBrokerComponents ||
      this.showBrokerAdminComponents ||
      this.showInternalUserComponents ||
      this.showSysAdminComponents
    ) {
      this.userService.getLoggedInUserDetails(this.user.username).subscribe({
        next: (data) => {
          if (data.status == 'SUCCESS') {
            this.loggedInUser = data;
            if (this.showAdminComponents) {
              this.isRestAPIEnabled = true;
              this.isEmbedAPIEnabled = true;
              this.isDWMAPIEnabled = true;
              this.isExternalAPIEnabled = true;
              this.feedAPIEnabled = true;
            } else {
              this.isRestAPIEnabled = this.loggedInUser.openAPIEnabled === 1;
              this.isEmbedAPIEnabled = this.loggedInUser.embedAPIEnabled === 1;
              this.isDWMAPIEnabled = this.loggedInUser.dwmAPIEnabled === 1;
              this.isExternalAPIEnabled =
                this.loggedInUser.backOfficeAPIEnabled === 1;
              this.feedAPIEnabled = this.loggedInUser.feedAPIEnabled === 1;
            }
          } else {
            this.toastr.error(data.reason, 'Getting user details failed');
          }
        },
        error: (err) => {
          this.toastr.error(err.error.message, 'Getting user details failed');
        },
      });
    } else if (this.showAdminComponents) {
      this.isRestAPIEnabled = true;
      this.isEmbedAPIEnabled = true;
      this.isDWMAPIEnabled = true;
      this.isExternalAPIEnabled = true;
    }
  }

  logout(): void {
    this.isLoggedIn = false;
    this.tokenStorageService.signOut();
    // keycloak.logout() performs a full-page redirect to the Keycloak
    // end-session endpoint and back to redirectUri — no router.navigate
    // afterwards (it raced the redirect and pointed at a nonexistent route)
    this.keycloakService.logout(environment.redirectUri);
  }

  async login() {
    await this.loginService.login();
  }

  openRegistration(event: Event) {
    event.preventDefault();
    this.registrationModalService.open();
  }

  isApisMenuOpen = false;

  @ViewChild('apisMenuContainer') apisMenuContainer?: ElementRef;

  toggleApisMenu() {
    this.isApisMenuOpen = !this.isApisMenuOpen;
  }

  get isApiPageActive(): boolean {
    return ['rest-api-reference', 'microinvest-api', 'invest-api'].includes(
      this.activePage,
    );
  }

  /** Label of the currently selected API shown on the dropdown toggle. */
  get selectedApiLabel(): string {
    switch (this.activePage) {
      case 'rest-api-reference':
        return 'Trade API';
      case 'microinvest-api':
        return 'Microinvest API';
      case 'invest-api':
        return 'Invest API';
      default:
        return 'APIs';
    }
  }

  async loadUserDetails() {
    this.isLoggedIn =
      !!this.keycloakService.getKeycloakInstance().authenticated;

    if (this.isLoggedIn) {
      this.userDetails = await this.keycloakService.loadUserProfile();
      const username = this.userDetails.username || '';
      const accessToken = await this.keycloakService.getToken();
      this.tokenStorageService.saveToken(accessToken);
      this.getUserDetails(username);
    }
  }

  getUserDetails(username: string): void {
    const primaryRoles = [
      'admin',
      'broker',
      'brokerAdmin',
      'internalUser',
      'sysAdmin',
    ];
    const secondaryRolesList = [
      'stockDeposit',
      'stockWithdraw',
      'stockTransfer',
      'topStocks',
      'appUrlIssuerDev',
      'appUrlIssuerQA',
      'appUrlIssuerSandbox',
      'appUrlIssuerAsiaUAT',
      'appUrlIssuerMenaUAT',
      'appUrlIssuerEuropeUAT',
      'appUrlIssuerUSUAT',
      'appUrlIssuerAsiaPROD',
      'appUrlIssuerMenaPROD',
      'appUrlIssuerEuropePROD',
      'appUrlIssuerUSPROD',
    ];

    this.userService.getLoggedInUserDetails(username).subscribe({
      next: (data) => {
        if (data.status === 'SUCCESS') {
          const primaryRole = data.role;
          const secondaryRoles = data.secondaryRoles;

          const user = {
            username: data.username,
            role: primaryRole,
            institution: data.institution,
            firstName: data.firstName,
            lastName: data.lastName,
            initialLoginFlag: data.isInitialLogin,
            region: data.environment,
            secondaryRole: secondaryRoles,
          };
          this.tokenStorageService.saveUser(user);

          this.tokenStorageService.saveUserEnv(user.region);
          if (user.initialLoginFlag === 1) {
            this.router.navigate(['/login/change-password']);
          } else {
            this.isLoggedIn = true;
            this.initialize();
          }
        } else {
          this.toastr.error(data.reason, 'Getting user details failed');
        }
      },
      error: (err) => {
        this.toastr.error(err.error.message, 'Getting user details failed');
      },
    });
  }

  @ViewChild('profileContainer') profileContainer!: ElementRef;

  isDrawerOpen = false;

  toggleDrawer() {
    console.log('toggleDrawer clicked');
    this.isDrawerOpen = !this.isDrawerOpen;
    console.log('isDrawerOpen', this.isDrawerOpen);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (
      this.isDrawerOpen &&
      this.profileContainer &&
      !this.profileContainer.nativeElement.contains(event.target)
    ) {
      this.isDrawerOpen = false;
    }
    if (
      this.isApisMenuOpen &&
      this.apisMenuContainer &&
      !this.apisMenuContainer.nativeElement.contains(event.target)
    ) {
      this.isApisMenuOpen = false;
    }
  }

  getInitials(email: string | undefined): string {
    if (!email) return '';
    const local = email.split('@')[0] || '';
    const parts = local.split('.').filter(Boolean);
    const first = parts[0] || '';
    const second = parts[1] || '';
    if (second.length > 0) {
      return (first[0] + second[0]).toUpperCase();
    }
    return first.slice(0, 2).toUpperCase();
  }

  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

  showLeftArrow = false;
  showRightArrow = false;

  ngAfterViewInit(): void {
    setTimeout(() => this.updateScrollArrows(), 0);
  }

  @HostListener('window:resize')
  onResize() {
    this.updateScrollArrows();
  }

  scrollMobileBar(direction: 'left' | 'right') {
    if (!this.scrollContainer?.nativeElement) return;

    const container = this.scrollContainer.nativeElement;
    const scrollAmount = 100;
    container.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });

    setTimeout(() => this.updateScrollArrows(), 300);
  }

  updateScrollArrows() {
    if (!this.scrollContainer?.nativeElement) return;

    const container = this.scrollContainer.nativeElement;
    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth;
    const clientWidth = container.clientWidth;

    this.showLeftArrow = scrollLeft > 0;
    this.showRightArrow = scrollLeft + clientWidth < scrollWidth - 1;
  }

  private setActiveFromUrl(url: string) {
    const cleanUrl = (url || '').split('?')[0].split('#')[0];
    if (
      cleanUrl.startsWith('/doc/trade') ||
      cleanUrl.startsWith('/rest-api-reference') ||
      cleanUrl.startsWith('/feed-api-reference')
    ) {
      this.activePage = 'rest-api-reference';
      return;
    }
    if (cleanUrl.startsWith('/doc/microinvest')) {
      this.activePage = 'microinvest-api';
      return;
    }
    if (cleanUrl.startsWith('/doc/invest')) {
      this.activePage = 'invest-api';
      return;
    }
    if (cleanUrl.startsWith('/external-api-reference#')) {
      this.activePage = 'external-api-reference#';
      return;
    }
    this.activePage = cleanUrl.split('/')[1] || '';
  }
}
